import React, { useEffect, useState } from "react";
import { FaApple, FaFacebook, FaGoogle, FaChevronRight } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoCaretBack } from "react-icons/io5";
import colors from "../config/colors";
import { shouldForwardProp } from "@mui/styled-engine";
import useApi from "../hooks/useApi";
import apiClient from "../api/apiClient";
import { useDispatch } from "react-redux";
import { login } from "../redux/counterSlice";
import * as yup from "yup";
import { Form, Formik } from "formik";
import { Spinner } from "react-bootstrap";

export default () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [role, setRole] = useState();
  const [validationErrors, setValidationErrors] = useState({});
  const [passwords,setpasswords]=useState()
  const validationSchemas =  yup.object({
    legal_first_name: yup.string().required("Legal First Name"),
    legal_last_name: yup.string().required().label("Legal Last Name"),
    email: yup.string().email().required().label("Email"),
    password: yup.string().required().label("Password"),
    password_confirm: yup
      .string()
      .required()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .label("Confirm Password"),
    account_type: yup.string().required().label("Account Type"),
    });
  
  let initialSignUp = {
    // role: state?.role,
    legal_first_name: "",
    legal_last_name: "",
    email: "",
    password: "",
    password_confirm: "",
    account_type: "",
  };
  const [data, setData] = useState(initialSignUp);
  // function handleChange(key, value) {


  //   setData({ ...data, [key]: value });

  //   if (key==="password_confirm"&&data.password) {
  //     if(data.password !==value)
  //   setValidationErrors({...validationErrors,password_confirm:"Password do not match."})
  // else
  // setValidationErrors({...validationErrors,password_confirm:""})
 
  //   }
  // }
  const [showPassword, setShowPassword] = useState(true);

  const { request, loading, error } = useApi((data) =>
    apiClient.post("/authentication/registration/", data)
  );
  async function handleSubmit(values,e) {
    // e.preventDefault();
    console.log(values,"aaa")
    
    
 
    const result = await request(values);
    console.log(result,"ddddd")

    if (!result.ok) 
 
    return
    
    
    console.log("error");
    handleNavigate();
  }
  useEffect(() => {
    document.title = "RollingAdz: Sign up" || "Default Title";
  }, []);

  function handleNavigate() {
    navigate("/waiting-page", { state: data.email });
  }

  // function handleNavigate() {
  //   if (role == "IN") navigate("/installeraccount");
  //   else if (role == "PH") navigate("/photograperaccount");
  //   else if (role == "AC") navigate("/advertiser-account");
  //   else if (role == "VO") navigate("/vehicleowneraccount");
  //   else if (role == "DE") navigate("/designeraccount");
  //   else navigate("/installeraccount");
  // }
  console.log(loading,'hjjgjhgjhgjgjgjhjgjhg')
  return (

<Formik
      initialValues={initialSignUp}
      validationSchema={validationSchemas}
      onSubmit={handleSubmit}
    >
      {({
        handleSubmit,
        setFieldValue,
        handleChange,
        setFieldTouched,
        values,
        errors,
        touched,
      }) => (
        <Form onSubmit={handleSubmit} autoComplete="off">

       

    <div>
      {/* Signup button popup */}

      
      <div className="main_2 d-flex justify-content-center align-items-center py-5">
        <div className="signin-box p-3 rounded-3 col-md-7">
          <div onClick={() => navigate(-1)}>
            <IoCaretBack size={35} color={colors.primary} />
          </div>
         
            {/* <h1 className="display-1 text-secondary h1 text-center"><i className="bi bi-truck" /></h1> */}
            <div className="login-form col-md-10 mx-auto">
              <div className=" login-head d-flex flex-column align-items-center justify-content-center">
               
                <ul
                  className="nav nav-pills mb-3 w-75 rounded-pill fs-2 text-white"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item w-50" role="presentation">
                    <button
                      onClick={() => navigate("/signin")}
                      className="nav-link text-white w-100 rounded-pill p-3"
                      id="pills-sigin-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-signin"
                      type="button"
                      role="tab"
                      aria-controls="pills-signin"
                      aria-selected="true"
                    >
                      Sign In
                    </button>
                  </li>
                  <li className="nav-item w-50" role="presentation">
                    <button
                      className="nav-link active text-white w-100 rounded-pill p-3"
                      id="pills-signup-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-signup"
                      type="button"
                      role="tab"
                      aria-controls="pills-signup"
                      aria-selected="false"
                    >
                      Sign Up
                    </button>
                  </li>
                </ul>
              </div>
              <input
                type="text"
                // onBlur={()=>setFieldTouched("legal_first_name")}
                
                // onChange={()=>
                //   handleChange("legal_first_name")
                // }    
                   onChange={(e) => setFieldValue('legal_first_name', e.target.value)}
                  onBlur={() => setFieldTouched('legal_first_name', true)}
                
                value={values.legal_first_name}
                placeholder="Legal First Name"
                className="form-control input shadow-none bg-transparent rounded-0 py-2 px-0 my-3 mx-0 border border-primary border-bottom-2 border-start-0 border-top-0 border-end-0 fs-5"
              />
               {errors.legal_first_name && (
          <div className="text-danger">{errors.legal_first_name}</div>
        )}
              <input
                type="text"
               
                // onChange={() =>
                //   handleChange("legal_last_name")
                // }
                onChange={(e) => setFieldValue('legal_last_name', e.target.value)}
                onBlur={() => setFieldTouched('legal_last_name', true)}
                value={values.legal_last_name}
                placeholder="Legal Last Name"
                className="form-control input shadow-none bg-transparent rounded-0 py-2 px-0 my-3 mx-0 border border-primary border-bottom-2 border-start-0 border-top-0 border-end-0 fs-5"
              />
                   {errors.legal_last_name && (
          <div className="text-danger">{errors.legal_last_name}</div>
        )}
              <input
                type="email"
                // value={data.email}
                value={values.email}
                // onChange={()=>handleChange("email")}
                onChange={(e) => setFieldValue('email', e.target.value)}
                onBlur={() => setFieldTouched('email', true)}
                placeholder="Email"
                className="form-control input shadow-none bg-transparent rounded-0 py-2 px-0 my-3 mx-0 border border-primary border-bottom-2 border-start-0 border-top-0 border-end-0 fs-5"
              />
                       {errors.email && (
          <div className="text-danger">{errors.email}</div>
        )}
              <div className="position-relative">
                <input
                  // value={data.password}
                  value={values.password}
                  // onChange={() => handleChange("password")}
                  onChange={(e) => setFieldValue('password', e.target.value)}
                  onBlur={() => setFieldTouched('password', true)}
                  className="form-control input shadow-none bg-transparent rounded-0 py-2 ps-0 pe-4 my-3 mx-0 border border-primary border-bottom-2 border-start-0 border-top-0 border-end-0 fs-5"
                  type={showPassword ? "password" : "text"}
                  name
                  id
                  placeholder="Password"
                />
                              {errors.password && (
          <div className="text-danger">{errors.password}</div>
        )}
                <button
                  type="button"
                  className="show-password bg-transparent border-0 position-absolute end-0 top-0 lh-lg fs-5"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="bi bi-eye-fill" />
                  ) : (
                    <i class="bi bi-eye-slash-fill" />
                  )}
                </button>
              </div>
              <div className="position-relative">
                <input
                  // value={data.password_confirm}
                  value={values.password_confirm}
                  // onChange={() =>
                  //   handleChange("password_confirm")
                  // }
                         onChange={(e) => setFieldValue('password_confirm', e.target.value)}
                  onBlur={() => setFieldTouched('password_confirm', true)}
                  className="form-control input shadow-none bg-transparent rounded-0 py-2 ps-0 pe-4 my-3 mx-0 border border-primary border-bottom-2 border-start-0 border-top-0 border-end-0 fs-5"
                  type={showPassword ? "password" : "text"}
                  name
                  id
                  placeholder="Confirm Password"
                />                     {errors.password_confirm && (
                  <div className="text-danger">{errors.password_confirm}</div>
                )}

                <button
                  type="button"
                  className="show-password bg-transparent border-0 position-absolute end-0 top-0 lh-lg fs-5"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="bi bi-eye-fill" />
                  ) : (
                    <i class="bi bi-eye-slash-fill" />
                  )}
                </button>
              </div>
              <div className="row pb-4 d-flex align-items-center justify-content-between">
                <div className="col-5">

                <span className="text-center fs-6 py-1 my-auto">
                  Account Type (choose one):
                </span>
                </div>
                {/* <div className="col-5">
                  <select
                    class="form-select px-2 fs-6 py-1 text-center"
                    aria-label="Default select example"
                    // onChange={() =>
                    //   handleChange("account_type")
                    // }
                    onChange={(e) => setFieldValue('account_type', e.target.value)}
                    onBlur={() => setFieldTouched('account_type', true)}
                  
                  >
                    <option selected disabled>
                      Select Advertiser Account
                    </option>
                    <option value="">None</option>
                    <option value="0">Agency</option>
                    <hr className="text-center w-75 text-primary" />
                    <option value="1">Company Direct</option>
                  </select>
                </div> */}
                {/* <div className="col-2 d-flex justify-content-center ">
                  <p className="text-primary  pt-2">OR</p>
                </div> */}
                <div className="col-5">
                  <select
                    class="form-select px-2 fs-6 py-1 text-center"
                    aria-label="Default select example"
                    // onChange={() =>
                    //   handleChange("account_type")
                    // }
                    onChange={(e) => setFieldValue('account_type', e.target.value)}
                    onBlur={() => setFieldTouched('account_type', true)}
                  >
                    <option selected disabled>
                      Select Vendor Type
                    </option>
                    {/* <option value="">None</option> */}
                    <option value="2">Vehicle Owner</option>
                    <hr className="text-center w-75 text-primary" />
                    <option value="3">Installer</option>
                    <hr className="text-center w-75 text-primary" />
                    <option value="4">Photographer</option>
                    <hr className="text-center w-75 text-primary" />
                    <option value="0">Agency</option>
                    <hr className="text-center w-75 text-primary" />
                    <option value="1">Company Direct</option>
                  </select>
                </div>
              </div>
              <div className="d-flex justify-content-center">

             { loading?  <Spinner/>:        <button
  type="button"
  className="login-btn bg-blue rounded-pill text-white fs-3 border-0 mt-2 px-5 lh-lg"
  onClick={handleSubmit}
  disabled={loading}

>

  Next <FaChevronRight />
</button>   }
    

              </div>
            </div>
          
        </div>
      </div>
    </div>
    </Form>)}
        </Formik>
  );
};
